import React from 'react';
import TextField from '@mui/material/TextField';
import ConfirmCancelDialog from '../../../dialog/components/ConfirmCancelDialog';
var LinkInput = function (_a) {
    var urlValue = _a.urlValue, showUrlInput = _a.showUrlInput, setUrlValue = _a.setUrlValue, setShowUrlInput = _a.setShowUrlInput, confirmLink = _a.confirmLink;
    var handleConfirm = function () {
        confirmLink();
    };
    var handleClose = function () {
        setShowUrlInput(false);
    };
    var handleLinkInputKeydown = function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            confirmLink();
        }
    };
    var handleUrlChange = function (event) {
        setUrlValue(event.target.value);
    };
    return (React.createElement(ConfirmCancelDialog, { title: 'Add Hyperlink', open: showUrlInput, onClose: handleClose, onCancel: handleClose, onConfirm: handleConfirm },
        React.createElement(TextField, { autoFocus: true, fullWidth: true, margin: "dense", id: "editor-hyperlink", label: "Hyperlink", type: "text", value: urlValue, onChange: handleUrlChange, onKeyDown: handleLinkInputKeydown })));
};
export default LinkInput;
//# sourceMappingURL=LinkInput.js.map